<!-- @format -->

<article class="study-wrapper" [class.selected]="selected" [class.dotted]="dottedBorder" data-cy="study-box">
  <div
    class="study-header"
    [class.attained]="attainedCredits !== null && attainedCredits !== undefined"
    role="heading"
    [attr.aria-level]="level">
    <ng-container *ngTemplateOutlet="nameClickAction.observed && nameClickable ? linkTitle : title"></ng-container>
  </div>
  <div class="study-content">
    <span class="study-content-header">
      <span>
        @if (type !== "STUDY_DRAFT") {
          <span>{{ code }} | </span>
        }
        {{ "SIS_COMPONENTS.STUDY." + type | translate }}
      </span>
      <div class="study-content-badges">
        @if (studyState) {
          <sis-document-state-badge [state]="studyState"></sis-document-state-badge>
        }
        @if (isCrossStudyCourseUnit) {
          <sis-tiny-badge [variant]="'primary'" [content]="'SIS_COMPONENTS.STUDY.CROSS_STUDY' | translate"></sis-tiny-badge>
        }
      </div>
    </span>
    @if (attainedCredits !== null && attainedCredits !== undefined) {
      <div class="row">
        @if (!isPartiallyAttained) {
          <div class="col-2 col-sm-1"><sis-icon icon="achievement" color="success"></sis-icon></div>
          <div class="col-10 col-sm-11 attainment-info">
            <div
              >{{ "SIS_COMPONENTS.STUDY." + (isSubstituted ? "SUBSTITUTED" : "ATTAINED") | translate }} ({{ attainedCredits }}
              {{ "CREDITS" | translate }})</div
            >
            <div>{{ "SIS_COMPONENTS.STUDY.ATTAINMENT_GRADE" | translate }}: {{ gradeId | grade: gradeScaleId | async }}</div>
          </div>
        }
        @if (isPartiallyAttained) {
          <div>
            <sis-icon icon="info"></sis-icon>
            {{ "SIS_COMPONENTS.STUDY.PARTIALLY_ATTAINED" | translate }}
            ({{ attainedCredits }} / {{ plannedCredits | creditRange }})
          </div>
        }
      </div>
    }
  </div>
  <ng-content select="[study-box=notifications]"></ng-content>
  @if (action) {
    <sis-study-action-box
      [action]="action"
      [actionInputId]="actionInputId"
      [actionInputName]="actionInputName"
      (actionChange)="actionChange.emit(id)"
      [selected]="selected"
      [inputType]="inputType"
      [studyInfo]="(_name || '') + ' ' + (credits | creditRange)">
    </sis-study-action-box>
  }
</article>

<ng-template #linkTitle>
  <sis-button [link]="true" (clicked)="nameClickAction.emit(id)">
    <ng-container *ngTemplateOutlet="title"></ng-container>
  </sis-button>
</ng-template>

<ng-template #title> {{ _name }} ({{ credits | creditRange }}) </ng-template>
